export default "__VITE_ASSET__SYBmIAr___ 120w, __VITE_ASSET__B3Y4dHzP__ 240w, __VITE_ASSET__CoC99xe___ 480w, __VITE_ASSET__V40Mcy4y__ 512w";